<template>
  <div>
    <div @click="launchFile()">
      <slot name="activator"></slot>
    </div>
    <input type="file"
       ref="file"
       :name="filename"
       v-on:change="changeFile($event.target.files)"
       style="display:none">
    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        class="pa-0 ma-0"
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar color="red accent-2" size="30">
              <v-icon color="white" large>mdi-alert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-card-text class="caption white--text pa-0">
                {{ response }}
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'video-input',
    data: () => ({
      dialog: false,
      filename: 'file',
      response: '',
      process: {
        run: false
      }
    }),
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      async changeFile (file) {
        let video = file[0]
        let vid = document.createElement('video')
        let duration = 0
        vid.src = URL.createObjectURL(video)
        vid.ondurationchange = function() {
          duration = this.duration / 60
        }
        if (file.length > 0) {
          if (!video.type.match('video/mp4')) {
            this.dialog = true
            this.response = 'Silahkan pilih file dengan format video'
          // } else if (video.size > 209715200) {
          //   this.dialog = true
          //   this.response = 'Maksimal file 200MB'
          } else {
            let formData = new FormData()
            formData.append("key", "59e51e5db668184d8c4a085fb8389c3acfd76a50")
            formData.append('file', video)
            this.process.run = true
            this.$emit("input", {
              add : this.process.run
            })
            fetch(`${process.env.VUE_APP_API_CDN}upload/files`, {
              method: "POST",
              body: formData
            })
            .then(res => res.json())
            .then(respon => {
              this.process.run = false
              this.$emit("input", {
                url: respon.data[0].original,
                duration: duration,
                add : this.process.run
              })
            })
          }
        }
      }
    }
  } 
</script>